
interface LoadingSkeletonProps {
  rows?: number
  type?: 'card' | 'table' | 'list'
}

export default function LoadingSkeleton({ rows = 3, type = 'card' }: LoadingSkeletonProps) {
  if (type === 'table') {
    return (
      <div className="space-y-3">
        <div className="h-10 bg-sky-200 rounded animate-pulse" />
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="h-12 bg-sky-500/10 rounded animate-pulse" />
        ))}
      </div>
    )
  }

  if (type === 'list') {
    return (
      <div className="space-y-2">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 p-3">
            <div className="w-10 h-10 rounded-full bg-sky-200 animate-pulse" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-sky-200 rounded w-3/4 animate-pulse" />
              <div className="h-3 bg-sky-500/10 rounded w-1/2 animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="light-card p-4 space-y-3">
          <div className="h-5 bg-sky-200 rounded w-2/3 animate-pulse" />
          <div className="h-4 bg-sky-500/10 rounded w-full animate-pulse" />
          <div className="h-4 bg-sky-500/10 rounded w-4/5 animate-pulse" />
          <div className="flex gap-2 pt-2">
            <div className="h-6 w-16 bg-sky-200 rounded-full animate-pulse" />
            <div className="h-6 w-16 bg-sky-200 rounded-full animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  )
}
